import { Injectable } from '@angular/core';
import { AbcCore } from '@barthauer/abc/core';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { Observable } from 'rxjs';

@Injectable()
export class WebApiService {
  constructor(private core: AbcCore, private config: AbcConfigService) {}

  queryChangePassword(oldPassword: string, newPassword: string, confirmPassword: string): Observable<ArrayBuffer> {
    const model: any = {};
    model.OldPassword = oldPassword;
    model.NewPassword = newPassword;
    model.ConfirmPassword = confirmPassword;

    return this.executeWebApiPOSTMethod(
      this.config.configuration.WebApi.BaseURL + '/api/Account/ChangePassword',
      model
    );
  }

  private executeWebApiPOSTMethod(url: string, body: any): Observable<ArrayBuffer> {
    return this.core.data.executeWebApiPOSTMethod(url, body, true);
  }
}
